import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { AUTHORSHIP_FIELD_NAMES } from '@cli-constants/generators.js'
export function createAuthorshipFields(): SchemaField[] {
  return AUTHORSHIP_FIELD_NAMES.map((name) => ({
    name,
    type: 'text' as const,
    required: false
  }))
}
